var scrolledTop = 0;	// How far we've scrolled down the page. Updates from renderWebPage() 
var screenHeight;
var reveals = [];
var isMobile = false;
var leadEventFired = false;
var heroOffset;
var gallery = $(document).find('.gallery');
var imgContainer = gallery.children('.image-container'); 
var img = imgContainer.children('img');
var imgOn = imgContainer.children('img.on');
var index = imgOn.index();
var windowW = $(window).width();
var heroHeight = $('.hero').height();
var header = $('header');
var siteLogo = $('.sitelogo');

var ytReady = false;
var player;
var playerWidth = 960;
var playerHeight = 480;

window.onYouTubeIframeAPIReady = function () {
	ytReady = true;
};

var $flp_launch = $('.buildingRender .js-mediaSwipe');
 $flp_launch.click(function () {
    setTimeout(function(){
      flpClosePageScroll();
    },500);
 });
 // drops user back down to availability section after closing out floor plan pdf view
 function flpClosePageScroll() {
    var $mediaSwipe_close_btn = $('button#mediaswipe-close-button');
    $mediaSwipe_close_btn.click(function(){
      $('body,html').animate({scrollTop: $('#buildingRender').offset().top });
    });
 }

$(function(){
	if ( $('.hero').length ) {
		heroOffset = $('.hero').offset().top;
	} else {
		heroOffset = 80;
	}
	instantiateListeners();
	gatherReveals();
	setupPage();
	stickNav();
	removeReveal();
	mobileNav();

	if ($("body").hasClass("home") && !isMobile) {
		if (ytReady) {
			initiateHomeVideo();
		} else {
			window.onYouTubeIframeAPIReady = function () {
			initiateHomeVideo();
			};
		}
	}

	if ( $('body').hasClass('amenities') ) {
		$('header nav li a').eq(0).addClass('on');
	} else if ( $('body').hasClass('residences') ) {
		$('header nav li a').eq(1).addClass('on');
	} else if ( $('body').hasClass('floorplans') ) {
		$('header nav li a').eq(2).addClass('on');

		/*
		var sightmapURL = 'https://sightmap.com/embed/my8pxdg3w19';
		if ( window.location.hash != "" ) {
			var unit = window.location.hash.split('#unit=');
			if ( unit.length > 1 ) {
				sightmapURL += '?display_details=1&unit_number='+unit[1];
        		$('.fl-launch').attr('href',sightmapURL);
        		if ( $(window).width() < 760 ) {
        			toll.mediaSwipe.open({
					    type : 'iframe',
					    src : sightmapURL,
					    addClass : "fullscreen",
					    fullscreen : true				 
					});
        		}
        		$('body,html').animate({scrollTop: $('#fp-viewer-frame').offset().top },250);   		
        	}
		}

		var iframe = document.createElement('iframe');
		iframe.src = sightmapURL;
		document.getElementById('fp-viewer-frame').appendChild(iframe);
		*/



	} else if ( $('body').hasClass('virtual-tours') ) {
		$('header nav li a').eq(3).addClass('on');

	} else if ( $('body').hasClass('amenities') ) {
		$('header nav li a').eq(0).addClass('on');
		
	} else if ( $('body').hasClass('neighborhood') ) {
		getPOIS();
		$('header nav li a').eq(3).addClass('on');

	} else if ( $('body').hasClass('developer') ) {
		$('header nav li a').eq(4).addClass('on');

	} else if ( $('body').hasClass('contact') ) {
		$('header nav li a').eq(5).addClass('on');

	} else if ( $('body').hasClass('thank-you') ) { 
		setTimeout(function(){
			$('html, body').animate({
	        	scrollTop: $(".copy").offset().top - 220 + 'px'
			}, 1200);
		},750);
	}
	
		
	renderWebPage();

}); // END DOC Ready



function initiateHomeVideo() {
	var videoID = $("#ytplayer").attr("data-videoid");
	player = new YT.Player("ytplayer", {
	  videoId: videoID,
	  setPlaybackQuality: "large",
	  suggestedQuality: "large",
	  playerVars: {
		modestbranding: true,
		rel: 0,
	  },
	  events: {
		onReady: function (e) {
		  player.setPlaybackQuality("large");
		  $("#ytplayer").addClass("loaded");
		  player.playVideo();
		  doPlayLoop();
		  player.setPlaybackQuality("large");
		  player.mute();
		  player.setVolume(0);
		  e.target.setPlaybackQuality("large");
		  player.setPlaybackQuality("large");
		},
	  },
	});
	positionVideo();
}


function positionVideo() {
	var paddingConst = 1.2;
	var newMediaWidth, newMediaHeight, newXPosition, newYPosition;
	var $player = $("#ytplayer");
	var playerRatio = playerWidth / playerHeight;
	var $container = $player.parent();
	var containerWidth = $container.width();
	var containerHeight = $container.height();
	var containerRatio = containerWidth / containerHeight;
  
	if (playerRatio > containerRatio) {
	  newMediaWidth = containerHeight * playerRatio * paddingConst;
	  newMediaHeight = containerHeight * paddingConst;
	  newXPosition = (containerWidth - newMediaWidth) / 2;
	  newYPosition = (containerHeight - newMediaHeight) / 2;
	} else {
	  newMediaWidth = containerWidth * paddingConst;
	  newMediaHeight = (containerWidth / playerRatio) * paddingConst;
	  newXPosition = (containerWidth - newMediaWidth) / 2;
	  newYPosition = (containerHeight - newMediaHeight) / 2;
	}
  
	$player.attr("width", Math.ceil(newMediaWidth + 1));
	$player.attr("height", Math.ceil(newMediaHeight + 1));
	$player.css({
	  left: Math.floor(newXPosition) + "px",
	  top: Math.floor(newYPosition) + "px",
	});
  }
  
  function checkPlayTime() {
	player.currentTime = new Date();
	if (player.getCurrentTime() > player.getDuration() - 4) {
	  player.seekTo(0.5);
	}
	doPlayLoop();
  }
  
  function doPlayLoop() {
	if (window.requestAnimationFrame) window.requestAnimationFrame(checkPlayTime);
	else if (window.msRequestAnimationFrame)
	  window.msRequestAnimationFrame(checkPlayTime);
	else if (window.webkitRequestAnimationFrame)
	  window.webkitRequestAnimationFrame(checkPlayTime);
	else if (window.mozRequestAnimationFrame)
	  window.mozRequestAnimationFrame(checkPlayTime);
	else if (window.oRequestAnimationFrame)
	  window.oRequestAnimationFrame(checkPlayTime);
	else if (typeof window.requestNextFrame === "undefined") {
	  window.requestNextFrame = setInterval(function () {
		checkPlayTime();
	  }, 18);
	}
  }

function setupPage() {
	screenHeight = $(window).height();
	for ( var i = 0; i < reveals.length; i++ ) {
		reveals[i].offset = reveals[i].domObject.offset().top;
	}
}

function gatherReveals() {
	$(document).find('.js-revealUp, .js-revealRight, .js-revealLeft, .js-revealOpacity').each(function() {
		reveals.push({
			domObject : $(this),
			offset : $(this).offset().top,
			triggered: false
		});
	});
}

function isMobileView() {
	if ( $(windowW) < 1051 ) {
		return true;
	} else {
		return false;
	}
}
/*
	validateForm
	-------------------------------------------------------------------------
	Validates a given form or finds a form in the document and returns true
	if all REQUIRED fields have values.
	
	@param $form - The jQuery selector of the form to validate.
	-------------------------------------------------------------------------
*/
	
function displayThankYou() {
	$(".js-form-container").hide();
	$(".js-thanks-container").show();
	submit_disabled = true;
}

function displayUhOh() {
	$(".js-form-container").hide();
	$(".js-oops-container").show();
	submit_disabled = true;
}

// make nav sticky	
function stickNav(){
	if (windowW > 768){
		if (heroHeight < scrolledTop){
			header.addClass('stick');
		} else {
			header.removeClass('stick');
		}
		if (scrolledTop > 420){
			header.addClass('noOpacity');
			header.removeClass('opacity');
                  siteLogo.addClass('scrollHide');
                  siteLogo.removeClass('scrollShow');
		} else if (scrolledTop < 420) {
			header.removeClass('noOpacity');
			header.addClass('opacity');
                  siteLogo.addClass('scrollShow');
			siteLogo.removeClass('scrollHide');
		}
	} else {
		header.removeClass('stick');
	}	
	
};

// // make subnav sticky	
// function substickNav(){
// 	if (windowW > 768){
// 		if (subheroHeight < scrolledTop){
// 			header.addClass('stick');
// 		} else {
// 			header.removeClass('stick');
// 		}
// 		if (scrolledTop > 220){
// 			header.addClass('noOpacity');
// 			header.removeClass('opacity');
//                   siteLogo.addClass('scrollHide');
//                   siteLogo.removeClass('scrollShow');
// 		} else if (scrolledTop < 220) {
// 			header.removeClass('noOpacity');
// 			header.addClass('opacity');
//                   siteLogo.addClass('scrollShow');
// 			siteLogo.removeClass('scrollHide');
// 		}
// 	} else {
// 		header.removeClass('stick');
// 	}	
	
// };


function mobileNav(){
	var winW = $(window).width();
	if(winW < 769){
		header.removeClass('stick').addClass('mobile');
	} else {
		header.removeClass('mobile');
	}
}

function removeReveal(){
	var winW = $(window).width();
	var h1Reveal = $(document).find('h1').parents('.wrapper').parents('.copy');
	if (winW < 801){
		h1Reveal.removeClass('js-revealUp');

	}
}
/*
	instantiateListeners
	-------------------------------------------------------------------------
	Sets all user events for the site.
	
	-------------------------------------------------------------------------
*/
function instantiateListeners() {

	// On Scroll Event
	// ----------------------------------
	$(window).on('scroll',function(){
		if (window.requestAnimationFrame)
			window.requestAnimationFrame(renderWebPage);
		else if (window.msRequestAnimationFrame)
			window.msRequestAnimationFrame(renderWebPage);
		else if (window.webkitRequestAnimationFrame)
			window.webkitRequestAnimationFrame(renderWebPage);
		else if (window.mozRequestAnimationFrame)
			window.mozRequestAnimationFrame(renderWebPage);
		else if (window.oRequestAnimationFrame)
			window.oRequestAnimationFrame(renderWebPage);
		else {
			QueueNewFrame = function () {};
			scrollInterval = setInterval(function(){renderWebPage();}, 16.7);
		}

		stickNav();
	});

	// On Window Resize
	// ----------------------------------
	$(window).resize(function(){
		renderWebPage();
		setupPage();
		mobileNav();
		removeReveal();
		if ( $('body').hasClass('neighborhood') ) {
			getPOIS();
		};
		
	});
}
// Input Events
	// ----------------------------------
	$('.input-wrapper input[type=text], .input-wrapper input[type=email], textarea').on('keypress', function(e) { 
		$(this).parent().addClass('focused');
	});
	$('.input-wrapper input[type=text], .input-wrapper input[type=email], textarea').on('focus', function(e) { 
		$(this).parent().addClass('focused');
				var code = (e.keyCode ? e.keyCode : e.which);
				if (code == 9) {
					$(this).parent().addClass('focused');
				}
	});
	$('.input-wrapper input[type=text], .input-wrapper input[type=email], textarea').on('keyup', function(e) { 
		var value = $(this).val().replace(/^\s\s*/g, '').replace(/\s\s*$/g, '');
		if ( value !== "" ) {
			$(this).parent().addClass('focused');
		} else {
			//$(this).parent().removeClass('focused');
		}
		if ( !leadEventFired ) {
			dataLayer.push({'event': "lead_initiated"});
			leadEventFired = true;
		}
	});
	$(document).on('blur', '.input-wrapper input[type=text], .input-wrapper input[type=email]', function(e) {
		
		var value = $(this).val().replace(/^\s\s*/g, '').replace(/\s\s*$/g, '');
		if ( value == "" ) {
			$(this).parent().removeClass('focused');
		}
	});
	$(document).on('focus', '.invalid', function(e) {
		$(this).removeClass('invalid');
		$('.errors').hide();
	});

	


// Radio Button Events
	// ----------------------------------
	$('input[type=radio]').on('change', function(e) {
		if ( !$(this).is(':checked') ) {
			return false;
		}

		// Disable associated content
		var $disableContent = $('.'+$(this).attr('data-disable'));
		$disableContent.addClass('disabled');
		$disableContent.find('.input-wrapper').each(function() {
			$(this).removeClass('focused');
			$(this).find('input[type=text]').val('').attr('disabled','');
		});


		// Enable associated content
		if ( typeof $(this).attr('data-enable') !== 'undefined' ) {
			var $enableContent = $('.'+$(this).attr('data-enable'));
			$enableContent.removeClass('disabled');
			$enableContent.find('.input-wrapper').each(function() {
				$(this).removeClass('focused');
				$(this).find('input[type=text]').each(function() {
					$(this).val('');
					var thisID = $(this).attr('id');
					document.getElementById(thisID).disabled = false;
				});
			});
		}

	});
	$(document).on('click', '.radio-label', function(e) {
		if ( !isMobile && !$(this).hasClass('checked') ) {
			$(this).parent().find('.checked').removeClass('checked');
			$(this).addClass('checked');
		}
	});
	$(document).on('touchstart', '.radio-label', function(e) {
		if ( !$(this).hasClass('checked') ) {
			$(this).parent().find('.checked').removeClass('checked');
			$(this).addClass('checked');
		}
	});


	$(document).on('click', '.js-requestInfo', function(e) {
		if ( screenHeight >= 775 && !isMobile ) {
			e.preventDefault();
			var interest = $(this).attr('data-interested');
			$('#res-form').addClass('on');
			$('body').addClass('ms-prevent-scroll');
			$('input[name=comments]').val(interest);
		}
	});
	$(document).on('click', '.js-closeForm', function(e) {
		$('#res-form').removeClass('on');
		$('body').removeClass('ms-prevent-scroll');
	});
	$(document).on('click', '.discoverMore', function(){
		$('html, body').animate({
	        scrollTop: $(".copy").offset().top - 150
		}, 720);
	});
	$(document).on('touchstart', '.js-closeForm', function(e) {
		$('#res-form').removeClass('on');
		$('body').removeClass('ms-prevent-scroll');
	});
	$(document).on('touchstart', '.discoverMore', function(){
		$('html, body').animate({
	        scrollTop: $(".copy").offset().top - 150
	    }, 720);
	});



// Dropdown Events
	// ----------------------------------
	$(document).on('click', '.dropdown-button', function(e) {
		e.preventDefault();
		var $list = $(this).parent().find('.dropdown-options');
		if ( $list.hasClass('on') ) {
			$list.removeClass('on');
		} else {
			$list.addClass('on');
		}
	});
	$(document).on('click', '.dropdown-option', function(e) {
		var $btn = $(this);
		var val = $btn.val();
		var trueVal = $btn.attr('data-truevalue');
		var $buttonText = $btn.parent().parent().find('label');
		var $hiddenInput = $btn.parent().parent().find('.hidden-input');
		var $dropdownList = $btn.parent();
		$dropdownList.parent().removeClass('invalid');
		$buttonText.html( val );
		$hiddenInput.val( trueVal );
		$dropdownList.find('.on').removeClass('on');
		$btn.addClass('on');
		$btn.parent().removeClass('invalid');
	});
	$(document).mouseup(function(e) {
		$(document).find('.dropdown-wrapper').each(function(){
			var dropdown = $(this);
			if ( !dropdown.is(e.target) && !dropdown.children('button').is(e.target) && !dropdown.find('.dropdown-options button').is(e.target) ) {
				dropdown.find('.dropdown-options').removeClass('on');
			}
		});
		if ( $('#res-form').is(e.target) && !$('#res-form').children('form-wrapper').is(e.target) ) {
			$('#res-form').removeClass('on');
			$('body').removeClass('ms-prevent-scroll');
		}
	});



// LOGO ANIMATION
	setTimeout(function(){

		$('.sitelogo').addClass('on');

	},500);

/*
	renderWebPage
	-------------------------------------------------------------------------
	Handler for on document scroll or window resize events.
	
	-------------------------------------------------------------------------
*/
function renderWebPage() {
	scrolledTop = $(window).scrollTop();
	if ( reveals.length ) {
		for ( var i = 0; i < reveals.length; i++ ) {
			if ( scrolledTop + screenHeight + 200  > reveals[i].offset && reveals[i].triggered === false ) {
				reveals[i].domObject.addClass('animateIn');
				reveals[i].triggered = true;
			}
		}
	}
}

function getPOIS() {
	var pois = [];
	
	pois.push({
		name : 		'151 Bay Street',
		latlong: 	'40.753556, -74.025991',
		alwaysVisible: true,
		icon:       '/images/map-icon.png',
        iconWidth: 	70,
        iconHeight: 77
	});

	var mapIconIndex = 2;

	$(document).find('.poi-list').each(function() {
		var category = $(this).children('ol').attr('class');
		var listItemCount = 0;
		$(this).find('ol li').each(function() {

			if ( listItemCount%2 == 0 ) {
				$(this).addClass('even');
			}

			$(this).attr('data-index',mapIconIndex);

			pois.push({
				name: 		$(this).children('span').html(),
				latlong: 	$(this).attr('data-latlong'),
				icon: 		'https://cdn.tollbrothers.com/lifestyles/tollmaps/blank.gif',
				label: 		true,
				number:		$(this).children('span.number').html(),
				labelHTML: 	'<div class="{className}">{categoryID}</div>',
				address:	$(this).attr('data-address'),
				category: 	category,
				onhover: function(d) {
					toll.map.showInfoWindow(d);
				},
			});

			listItemCount++;
			mapIconIndex++;
		});
	});		
				
	toll.map.init( 
	    'map',
	    {
	        zoom:           13,
	        loadOnScroll: 	false,
			category: 		'restaurants',
			infoWindow: 	
							'<span class="img"><span class="num">{number}</span><img src="/images/poi-hover-pin.png"></span>' +
							'<span class="title">{name}</span>' +
							'<p>{address}</p>' ,
					
			style : 		[{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"lightness":20},{"visibility":"on"},{"color":"#e6e3dc"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#a7bca5"},{"lightness":21},{"visibility":"on"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"visibility":"on"},{"color":"#ff0000"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.highway","elementType":"labels.text","stylers":[{"visibility":"on"},{"hue":"#ff0000"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"lightness":17},{"visibility":"on"},{"color":"#9fadac"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#7ca6ba"}]}]
			
			
		},
		
	    pois,
	    function() {
	    	showPOI('restaurants');
	    }
	);
}

function showPOI( category ) {
	$(document).find('.poi-list.on').removeClass('on').stop(true,false).animate({'height':'0px'},250);
	var $list = $(document).find('.poi-list.'+category);
	var listHeight = $list.children('ol').height() + parseFloat($list.children('ol').css('paddingTop')) + parseFloat($list.children('ol').css('paddingBottom'));
	var $aside = $(document).find('.poi-wrapper aside');
	var asideHeight = $(document).find('.poi-wrapper').height() - parseFloat($aside.css('paddingTop'));
	var buttonHeights = $('.poi-wrapper').find('.category-btn').length * ( $('.poi-wrapper .category-btn').eq(0).height() + parseFloat($('.poi-wrapper .category-btn').eq(0).css('marginBottom')) );
	var toHeight = (asideHeight - buttonHeights) + 'px';
	
	if ( windowW < 1051 ) {
		toHeight = 'auto';
		$list.addClass('on').stop(true,false).css({'height':toHeight});
	} else if(1051 < windowW && windowW < 1450){
		newHeight = 300;
		$list.addClass('on').stop(true,false).css({'height':newHeight});
	}
		else {
		$list.addClass('on').stop(true,false).animate({'height':toHeight},250);
	}
	toll.map.showCategory(category);
}

// Location POI Category
	// ----------------------------------
	$(document).on('click', '.js-toggleCategory', function(e) {
		$('.js-toggleCategory').removeClass('show');
		$(this).addClass('show');
		e.preventDefault();
		
		if ( $(this).hasClass('on') ) {
			return false;
		}
		showPOI($(this).attr('data-category'));	
		
	});
	$(document).on('mouseenter', '.js-highlightPOI', function(e) {
		$(document).find('.toll-map-label.highlight').removeClass('highlight');
		var index = parseInt($(this).attr('data-index'));
		$(document).find('.toll-map-label'+index).addClass('highlight');
		
	});
	$(document).on('mouseleave', '.js-highlightPOI', function(e) {
		$(document).find('.toll-map-label.highlight').removeClass('highlight');
	});

	// POI Hover
    // ----------------------------------
    $(document).on('mouseenter', '.js-highlightPOI', function(e) {
        var id = parseInt($(this).children('.number').html());
        toll.map.showInfoWindow(id);
	});

	
// galleries
$('.gallery').each(function(){
	var imgCon = $(this).children('.image-container');
	var image = imgCon.children('img');
	var imageOn = imgCon.children('img.on');
	var galNav = imgCon.children('.nav');
	var uList = galNav.children('ul');
	var inx = imageOn.index();
	var imageCount = image.length;
	var w = (20 * imageCount);
	for($i=0;$i<imageCount;$i++){
		galNav.children('ul').append('<li></li>');
	}
	galNav.children('ul').css('width', w);	
	uList.children('li').eq(index).addClass('on'); 
});

$(document).on('click', '.nav ul li', function(){
	dataLayer.push({'event': "photo_view"});
	var inx = $(this).index();
	$('.nav ul li').removeClass('on');
	$(this).addClass('on');
	img.removeClass('on');
	$(this).parents('.image-container').children('img').eq(inx).addClass('on');
	dataLayer.push({'event': "gallery_view"});
});

$(document).on('click','.gallery .next, .gallery .prev', function(){
	dataLayer.push({'event': "photo_view"});
	var direction = $(this).attr('class');
	var nav = $(this).siblings('.image-container').children('.nav').children('ul').children('li');
	var images = $(this).siblings('.image-container').children('img');
	var currentImg = $(this).siblings('.image-container').children('img.on');
	var currentIdx = currentImg.index();
	var last = images.length - 1;
	if(direction == 'next'){
		images.removeClass('on');
		nav.removeClass('on');
		if (currentIdx == last){
			images.eq(0).addClass('on');
			nav.eq(0).addClass('on');
		} else {
			images.eq(currentIdx+1).addClass('on');
			nav.eq(currentIdx+1).addClass('on');
		}
	} else if(direction == 'prev'){
		images.removeClass('on');
		nav.removeClass('on');
		images.eq(currentIdx-1).addClass('on');
		nav.eq(currentIdx-1).addClass('on');
		
	}
	dataLayer.push({'event': "gallery_view"});
});



$(document).on('click', '.mobile-btn', function(e){
	e.preventDefault();
	if($(this).hasClass('show')){
		$(this).removeClass('show');
	} else {
		$(this).addClass('show');
	};
	
	$('.sitelogo.tablet-show').toggleClass('on');
	if($('.mobile nav').hasClass('show')){
		$('.mobile nav').removeClass('show');
	} else {
		$('.mobile nav').addClass('show');
	}
	
	if($('header.mobile').hasClass('show')){
		$('header.mobile').removeClass('show');
	} else {
		$('header.mobile').addClass('show');
	}
	if($(this).hasClass('hide')){
		$(this).removeClass('hide');
	} else {
		$(this).addClass('hide');
	}
});

$('.directions').on('click', function(){
	dataLayer.push({'event': "get_directions"});
});


// Wait until the DOM is fully loaded
document.addEventListener("DOMContentLoaded", function() {
    // Get the close button element using its data-testid attribute
    var closeButton = document.querySelector('button[data-testid="close-contact"]');
    
    // Get the open div element using its data-testid attribute
    var openButton = document.querySelector('button[data-testid="open-contact"]');

    // Add a click event listener to the close button
    closeButton.addEventListener('click', function() {
        // Get the popup modal element by its ID
        var popupModal = document.getElementById('popupModal');

        // Set the display style to 'none' to hide the modal
		popupModal.classList.remove('show');
    });

    // Add a click event listener to the open div
    openButton.addEventListener('click', function() {
        // Get the popup modal element by its ID
        var popupModal = document.getElementById('popupModal');

        // Set the display style to 'block' to show the modal
		popupModal.classList.add('show');
    });
});
